<script lang="ts">
  import { run } from "svelte/legacy";

  import Heading from "../atoms/Heading.svelte";
  import NumberInput from "../atoms/NumberInput.svelte";
  import ErrorText from "../atoms/ErrorText.svelte";
  import { pinValidator } from "../../helpers/validators";
  import Button from "../atoms/Button.svelte";
  import PnrInformation from "../atoms/PnrInformation.svelte";
  import PnrInfoAlert from "./PnrInfoAlert.svelte";

  interface Props {
    isLoading: boolean;
    socialSecurity: number | undefined;
    valid?: boolean;
    onChange: (number: number) => void;
    onGetPerson: () => void;
    error?: boolean;
    disableInputs?: boolean;
    hasPressedContinue?: boolean;
    hideFetchAutomatically?: boolean;
  }

  let {
    isLoading,
    socialSecurity = $bindable(),
    valid = $bindable(),
    onChange,
    onGetPerson,
    error = false,
    disableInputs = false,
    hasPressedContinue = $bindable(false),
    hideFetchAutomatically = false,
  }: Props = $props();

  $effect(() => {
    if (socialSecurity != undefined) {
      valid = pinValidator(socialSecurity.toString());
    } else {
      valid = false;
    }
  });
</script>

<Heading>Dina uppgifter</Heading>
<PnrInformation class="my-2">
  <span class="text-H5 leading-6 text-Neutral900"
    >Kom ihåg att samma person som tecknar elhandelsavtalet behöver stå på elnätsavtalet.</span
  >
</PnrInformation>
<div class="fade-in mb-4">
  <div class="flex space-x-2">
    {#if (!valid && hasPressedContinue) || (!valid && socialSecurity && socialSecurity?.toString().length >= 10)}
      <ErrorText>Ogiltigt personnummer (ÅÅÅÅMMDDXXXX)</ErrorText>
    {:else}
      <span class="text-M"
        >Personnummer {disableInputs ? "(erbjudandet är personligt)" : "(ÅÅÅÅMMDDXXXX)"}</span
      >
    {/if}
    <PnrInfoAlert />
  </div>
  <div class="notranslate">
    <div class="flex space-x-8 items-center">
      <NumberInput
        onInput={() => onChange(10)}
        max={12}
        autoFocusDelay={false}
        autoFocus={false}
        disabled={disableInputs}
        error={!valid && socialSecurity !== undefined && socialSecurity?.toString().length >= 10}
        class="block flex-1 flex-shrink-0"
        bind:value={socialSecurity}
        {hasPressedContinue}
      />
      {#if !disableInputs && !hideFetchAutomatically}
        <Button
          disabled={!valid}
          animate={false}
          class="w-48 mt-1 flex-shrink-0"
          onClick={onGetPerson}
          loading={isLoading}
        >
          Hämta automatiskt
        </Button>
      {/if}
    </div>
  </div>

  {#if error}
    <div class="flex-0">
      <ErrorText>
        Något gick fel, kontakta vår kundservice på <a href="tel:+46910772550">0910-772550</a> så hjälper
        vi dig att teckna avtalet.
      </ErrorText>
    </div>
  {/if}
</div>
